import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Radio from '@mui/material/Radio';
import {string} from 'prop-types';
import React from 'react';

const Setting = ({selected, onChange, value, description, example}) => {
  const handleOnClick = () => {
    if (!selected) {
      onChange(value);
    }
  };
  return (
    <ListItem disablePadding>
      <ListItemButton
        role={undefined}
        onClick={handleOnClick}
        dense
        sx={{
          paddingInline: 1,
          paddingBlock: 0,
        }}
      >
        <ListItemIcon sx={{minWidth: 36}}>
          <Radio
            color="primary"
            value={value}
            checked={selected}
            disableRipple
          />
        </ListItemIcon>

        <ListItemText
          primary={description}
          secondary={example}
          slotProps={{
            primary: {
              variant: 'body1',
            },
            secondary: {
              variant: 'caption',
              component: 'p',
              color: 'text.primary',
            },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

Setting.propTypes = {
  description: string.isRequired,
  example: string,
  value: string.isRequired,
  group: string.isRequired,
};

export default Setting;
